export default __webpack_public_path__ + "static/media/small_head_-1.73deb6d1.webp";